<template>
  <div class="circuit-viz-pro">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="main-layout vertical">
      <!-- 渲染区 -->
      <div class="canvas-3d-wrapper">
        <svg width="100%" height="100%" viewBox="0 0 400 300">
           <!-- 电源 -->
           <rect x="180" y="20" width="40" height="20" fill="#333" rx="2" />
           <text x="200" y="34" text-anchor="middle" fill="#2ed573" font-size="10" font-weight="bold">直流电源</text>
           
           <!-- 导线与流动粒子 -->
           <g v-if="circuitMode === 'series'">
              <path id="seriesPath" d="M 200 40 L 200 70 L 100 70 L 100 230 L 300 230 L 300 70 L 200 70" fill="none" stroke="rgba(0, 210, 255, 0.2)" stroke-width="4" />
              <!-- 电灯 1 -->
              <circle cx="100" cy="150" r="15" :fill="isBroken ? '#333' : '#ffd700'" :shadow="isBroken ? 'none' : '0 0 20px #ffd700'" />
              <!-- 电灯 2 -->
              <circle cx="300" cy="150" r="15" :fill="isBroken ? '#333' : '#ffd700'" />
              
              <!-- 流动电子 -->
              <circle r="3" fill="#00d2ff" v-if="!isBroken">
                 <animateMotion dur="2s" repeatCount="indefinite" path="M 200 40 L 200 70 L 100 70 L 100 230 L 300 230 L 300 70 L 200 70" />
              </circle>
           </g>

           <g v-else>
              <!-- 并联路径 -->
              <path d="M 200 40 L 200 70 L 100 70 L 100 230 L 200 230 L 200 40" fill="none" stroke="rgba(0, 210, 255, 0.1)" stroke-width="4" />
              <path d="M 200 70 L 300 70 L 300 230 L 200 230" fill="none" stroke="rgba(0, 210, 255, 0.1)" stroke-width="4" />
              
              <!-- 支路 1 -->
              <circle cx="100" cy="150" r="15" :fill="isBroken ? '#333' : '#ffd700'" />
              <!-- 支路 2 -->
              <circle cx="300" cy="150" r="15" fill="#ffd700" />
              
              <!-- 电子 1 -->
              <circle r="3" fill="#00d2ff" v-if="!isBroken">
                 <animateMotion dur="2s" repeatCount="indefinite" path="M 200 40 L 200 70 L 100 70 L 100 230 L 200 230 L 200 40" />
              </circle>
              <!-- 电子 2 -->
              <circle r="3" fill="#00d2ff">
                 <animateMotion dur="1.5s" repeatCount="indefinite" path="M 200 40 L 200 70 L 300 70 L 300 230 L 200 230 L 200 40" />
              </circle>
           </g>
        </svg>

        <div class="hud-top">
           <div class="data-box">
              <label>支路状态</label>
              <span :class="isBroken ? 'danger' : 'safe'">{{ isBroken ? '断路' : '通路' }}</span>
           </div>
        </div>
      </div>

      <!-- 控制面板 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row">
               <el-button type="warning" size="mini" @click="isBroken = !isBroken">
                  {{ isBroken ? '修复断路' : '模拟人为断路 (拆除一个灯泡)' }}
               </el-button>
            </div>
         </div>

         <div class="guide-box">
            <div class="point">
               <p v-if="circuitMode === 'series'"><strong>串联：</strong>电流只有一条路径。一个灯泡坏了，整条电路都会熄灭（一断全断）。</p>
               <p v-else><strong>并联：</strong>电流有分支。一个灯泡拆除，不影响其他支路的正常发光。</p>
            </div>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeriesParallelViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      circuitMode: 'series',
      isBroken: false
    }
  },
  watch: {
    circuitMode() { this.isBroken = false; }
  }
}
</script>

<style scoped lang="scss">
.circuit-viz-pro {
  flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden;
}
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; font-weight: 300; } }
.canvas-3d-wrapper {
  flex: 1.5; background: #0a0a0f; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
  .hud-top { position: absolute; top: 15px; left: 15px; .data-box { background: rgba(255,255,255,0.05); padding: 5px 12px; border-radius: 6px; label { display: block; font-size: 0.6rem; color: #888; } span { color: #fff; font-size: 0.85rem; &.danger { color: #ff4757; } } } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; padding-bottom: 5px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 12px; display: flex; justify-content: center; }
.guide-box { background: rgba(0, 210, 255, 0.05); border-radius: 12px; padding: 12px 15px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
